import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { AncillaryStatusData } from '@app/pages/ancillary-bundle-page/ancillary-bundle.interfaces';

@Component({
  selector: 'ancillary-status',
  templateUrl: './ancillary-status.component.html',
  styleUrls: ['./ancillary-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AncillaryStatusComponent {
  @Input() data: AncillaryStatusData;

  @Output() showAllBenefits = new EventEmitter<AncillaryStatusData>();
}
